import type { PaletteOptions } from '@mui/material/styles';

const brand = {
  black: '#010205',
  white: '#ffffff',
  hover: '#535457',
  disabled: '#949598',
  gold: '#D5A457',
  darkSurface: '#2A3D46',
  lightSurface: '#DFE1E3',
  darkText: '#2B2B2B',
  lightText: '#F8F8F8',
} as const;

const status = {
  success: '#197e19',
  warning: '#ffc900',
  error: '#cc1922',
  info: '#2F6690',
} as const;

const event = {
  registered: '#4DAA57',
  partnerRegistered: '#F95738',
  noBookingRequired: '#2F6690',
  notBooked: '#CA8D2F',
  personal: '#8E1CA3',
  maEvent: '#00897B',
} as const;

export type ThemeMode = 'light' | 'dark';

export const getPalette = (mode: ThemeMode): PaletteOptions => {
  if (mode === 'dark') {
    throw new Error('Dark mode palette is not implemented yet. See docs/plans/theme-unification-roadmap.md (Phase F).');
  }

  return {
    mode: 'light',
    primary: {
      main: brand.black,
      contrastText: brand.white,
    },
    secondary: {
      main: brand.white,
      contrastText: brand.black,
    },
    background: {
      default: brand.white,
      paper: brand.white,
    },
    text: {
      primary: brand.darkText,
      secondary: brand.hover,
      disabled: brand.disabled,
    },
    success: { main: status.success },
    warning: { main: status.warning },
    error: { main: status.error },
    info: { main: status.info },
    eventCategory: {
      registered: event.registered,
      partnerRegistered: event.partnerRegistered,
      noBookingRequired: event.noBookingRequired,
      notBooked: event.notBooked,
      personal: event.personal,
      maEvent: event.maEvent,
    },
    brand: {
      darkSurface: brand.darkSurface,
      lightSurface: brand.lightSurface,
      gold: brand.gold,
      darkText: brand.darkText,
      lightText: brand.lightText,
    },
  };
};
